import {
  GET_LAYOUT_SPEC,
  GET_MENU_SPEC,
  GET_APP_ENDPOINT,
  GET_QUICK_LINKS,
  HIDE_ALERT,
  REMOVE_LAYOUT_SPEC,
  SHOW_ERROR,
  SHOW_MESSAGE,
  TOGGLE_APP_DRAWER,
} from 'shared/constants/ActionTypes';

const commonRuducerInitialState = {
  error: null,
  message: null,
  layoutSpecsById: {}, // { 'l-ab32': { ...data }, 'l-6zTz': { ...data } }
  isAppDrawerOpen: false,

  // dashboard specific
  menuSpecs: [],
  quickLinks: [],
  appEndPoint: '',
};

/**
 * Global Actions: Use CommonReducer (for global loading).
 */
const CommonReducer = (state = commonRuducerInitialState, action) => {
  switch (action.type) {
    case SHOW_MESSAGE:
      return {...state, message: action.payload, error: null};

    case SHOW_ERROR:
      return {...state, message: null, error: action.payload};

    case HIDE_ALERT:
      return {...state, message: null, error: null};

    case GET_MENU_SPEC:
      return {
        ...state,
        menuSpecs: action.payload,
      };

    case GET_QUICK_LINKS:
      return {
        ...state,
        quickLinks: action.payload,
      };

    case GET_LAYOUT_SPEC:
      return {
        ...state,
        layoutSpecsById: {
          ...state.layoutSpecsById,
          [action.layoutId]: action.payload,
        },
      };
    case GET_APP_ENDPOINT: {
      return {
        ...state,
        appEndPoint: action.payload,
      };
    }
    case REMOVE_LAYOUT_SPEC: {
      const nextSpec = {...state.layoutSpecsById};
      delete nextSpec[action.layoutId]; // Total removal
      return {
        ...state,
        layoutSpecsById: nextSpec,
      };
    }
    case TOGGLE_APP_DRAWER: {
      return {
        ...state,
        isAppDrawerOpen: !state.isAppDrawerOpen,
      };
    }

    default:
      return state;
  }
};
export default CommonReducer;
